import React from 'react';

import FlowIcon from './flowIcon.svg?react';

function FarmbotFlowIcon() {
  return <FlowIcon width={18} />;
}

export default FarmbotFlowIcon;
